import { render, staticRenderFns } from "./MyOffereds.vue?vue&type=template&id=2f9c75a6&scoped=true&"
import script from "./MyOffereds.vue?vue&type=script&lang=js&"
export * from "./MyOffereds.vue?vue&type=script&lang=js&"
import style0 from "./MyOffereds.vue?vue&type=style&index=0&id=2f9c75a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9c75a6",
  null
  
)

export default component.exports